import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { driver } from "driver.js";


@Component({
  selector: 'vex-register-weight',
  templateUrl: './register-weight.component.html',
  styleUrls: ['./register-weight.component.scss']
})
export class RegisterWeightComponent implements OnInit {
  weigth: any;
  unit: string = 'KG';

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService) { }

  ngOnInit() {
    setTimeout(() => {
      localStorage.getItem('tourWorkoutExecutionRegisterWeightShowed') ? null : this.startTour();
    }, 800);
  }

  confirmWeigth(){
    this.dialogRef.close({weight: this.weigth, unit: this.unit})
  }

  history(){
    this.dialogRef.close('history');
  }

  startTour(): void {
    localStorage.setItem('tourWorkoutExecutionRegisterWeightShowed', 'true');

    const input = document.querySelector('.insert-weigth input') as HTMLInputElement;
    if (input) {
      input.setAttribute('tabindex', '-1');  // disattiva focus temporaneamente
    }

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      allowKeyboardControl: false,
      steps: [
        { element: '.insert-weigth', popover: { title: this.translate.instant('TUTORIALS.workout-execution.enterWeightTitle'), description: this.translate.instant('TUTORIALS.workout-execution.enterWeightDescription') } },
        { element: '.select-unit', popover: { title: this.translate.instant('TUTORIALS.workout-execution.chooseUnitTitle'), description: this.translate.instant('TUTORIALS.workout-execution.chooseUnitDescription')} },
        { element: '.confirm-weigth', popover: { title: this.translate.instant('TUTORIALS.workout-execution.confirmTitle'), description: this.translate.instant('TUTORIALS.workout-execution.confirmDescription') } }]
    });

    driverObj.drive();
  }

}
